module.exports = __webpack_public_path__ + "static/media/marilyn.e6809ebb.png";